import { folder } from "utils/constants";

export const foldersData = [
  {
    id: 1,
    name: "Arquivos",
    created: 1558545033
  }
];

export const mediasData = [
  {
    id: 1,
    file: folder,
    name: "Cartografia",
    folder_id: 1,
    created: 1558545033
  }
];
